module.exports = __webpack_public_path__ + "static/media/academy-logo.620c02b9.png";